import React, { useEffect, useRef, useState } from "react";
import {
  BiMailSend,
  BiTrashAlt,
  BiRefresh,
  BiMobileVibration,
  BiCheck,
  BiPlusCircle,
  BiXCircle,
  BiUpArrowAlt,
  BiDownArrowAlt,
} from "react-icons/bi";
import { IoQrCodeOutline } from "react-icons/io5";
import { CSVLink } from 'react-csv'
import { BsDownload } from 'react-icons/bs'
import downloadCSV from "../../../../utils/csvDownloadHelper";
import ReactTooltip from "react-tooltip";
import {
  Button,
  Col,
  Row,
  FormGroup,
  Alert,
  Card,
  Input,
  ModalBody,
  ModalHeader,
  Modal,
  Badge,
} from "reactstrap";
import SlackSharePopup from "../../../../components/SlackAndTeamsPopups/SlackSharePopup";
import TeamsSharePopup from "../../../../components/SlackAndTeamsPopups/TeamsSharePopup";
import {
  baseUrl,
  formatPhoneNumber,
  OVERTIME_TEXT,
  NOTE,
  TIP,
  profilePicValidityCheck,
  TRIVIA_DESCRIPTION,
  TRIVVY_SLACK_MEMEBER_MESSAGE,
} from "../../../../utils/constants";
import axios from "../../../../axios";
import * as url from "../../../../utils/url";
import { toastContainer } from "../../../../utils/toast";
import Select from "react-select/lib/Select";
import {
  isPublishedDateGreaterThanGivenDate,
  TRIVIA_SHARE_PRIVACY_OPTIONS,
  TRIVIA_USER_IDENTIFICATION_OPTIONS,
} from "../../data";
import CheckBox from "rc-checkbox";
import { QRCodeCanvas } from "qrcode.react";
import moment from "moment";
import { orderBy } from "lodash";
import {
  ActionLayoutData,
  LayoutData,
  LayoutHeading,
  LayoutRow,
} from "../../../weekly-wins/TableLayoutComponents";
import { isMobile } from "../../../../utils/deviceInfo";
import { MdOutlineMobileFriendly, MdUpload } from "react-icons/md";
import SendSmsTextQuestionsModal from "./SendSmsTextQuestionsModal";
import OoPopover from "../../../../components/UI/Popover/OoPopover";
import { PiPaperPlaneRightFill } from "react-icons/pi";
import "./sharepage.css";
import { FaLinkedin, FaSlack, FaWhatsapp, FaRegCopy } from "react-icons/fa";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import FilterSelector from "./FilterSelector";
import PaginatedUserList from "./PaginatedUserList";
import MessagesSharingOptions from "./MessagesSharingOptions";
import TrivvySharingOptions from "./TrivvySharingOptions";
import privacyIcon from '../../../../assets/privacy_icon.svg'

export default function NewShareTriviaComponent({
  user,
  surveyId,
  setCurrentQuestion,
  survey,
  editCurrentTriviaShareData,
  callApiToAutoSave,
  setCurrentTrivia,
  publishTriviaApiCall,
  ...props
}) {
  const isOwner = false;
  const shareUrl = `${baseUrl()}home/trivia/${user.profile.organizationId._id
    }/quiz/${surveyId}/start`;
  const copySurveyUrl = () => {
    setIsCopied(true);
    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
    window.navigator.clipboard.writeText(`${shareUrl}?medium=copy`);
  };

  const [listingType, setListingType] = useState();

  const [allowSendLimitSMS, setAllowSendLimitSMS] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [sortParams, setSortParams] = useState({ sortBy: "user", sortOrder: "asc" });
  const [newUserRows, setNewUserRows] = useState([
    { name: "", mobileNumber: "" },
  ]);
  const [options, setOptions] = useState([]);
  const newUser = newUserRows[0];
  const innerRef = useRef();
  const innerRef2 = useRef();
  const skipSharedUsersReset = useRef(false);
  const [isDateArray, setIsDateArray] = useState([]);
  const [typesArray, setTypesArray] = useState({});


  const handleNewUserRowChange = (value, key, index) => {
    const rows = [...newUserRows];
    rows[index][key] = value;
    setNewUserRows(rows);
  };

  const isNewUser = (usr) => {
    const usersAll = [...usersListAll];
    if (usr.email || usr.mobileNumber) {
      const user = usersAll.find(
        (x) =>
          usr._id ||
          (usr.email &&
            x.email &&
            usr.email.trim().toLowerCase() === x.email.trim().toLowerCase()) ||
          (usr.mobileNumber &&
            x.mobileNumber &&
            usr.mobileNumber.trim() === x.mobileNumber.trim())
      );

      if (user) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  const handleInputChange = (value) => {
    // Filter options based on input value
    const filteredOptions = originalOptions.filter((option) =>
      option.label.toLowerCase().includes(value.toLowerCase())
    );
    if (filteredOptions.length == 0) {
      if (isNaN(value)) {
        setNewUserRows([{ ...newUserRows[0], name: value }]);
      } else {
        setNewUserRows([{ ...newUserRows[0], mobileNumber: value }]);
      }
    }
    setOptions(filteredOptions);
  };

  const [smsUsers, setSmsUsers] = useState(0);

  const [emailSmsSendModal, setEmailSmsSendModal] = useState({
    open: false,
    type: "",
  });

  const [isCopied, setIsCopied] = useState(false);
  const [deletedIds, setDeletedIds] = useState([]);

  const [sendSmsTextModal, setSendSmsTextModal] = useState(false);
  const [usersChanged, setUsersChanged] = useState(false);
  const [pagination, setPagination] = useState({});


  const [showShareconfirm, setShowShareConfirm] = useState({
    display: false,
    emails: 0,
    sms: 0,
    allUsersTakenTrivvy: false,
    showResendOption: false,
    pendingUsersToRespond: 0,
  });


  const [showLimitSMSAlert, setShowLimitSMSAlert] = useState({
    display: false,
    totalSMS: 0,
    remainingLimit: 0,
  });

  const [showDroppedUsersAlert, setShowDroppedUsersAlert] = useState(false);
  const [newUsersToSendSms, setNewUsersToSendSms] = useState(false);
  const [isConfirmNewUsersToSendSms, setIsConfirmNewUsersToSendSms] = useState(false);
  const [sendToDroppedUsers, setSendToDroppedUsers] = useState(null);

  const [messagingUsersData, setMessagingUsersData] = useState();
  const [displayPendingToSendAlert, setDisplayPendingToSendAlert] = useState(true);

  const totalUsers = messagingUsersData ? messagingUsersData.totalUsers + messagingUsersData.completedUsers : 0;
  const pendingToRespond = messagingUsersData ? messagingUsersData.pendingUsersToRespond : 0;
  const pendingUsersToRespond1 = messagingUsersData ? messagingUsersData.totalUsers - messagingUsersData.alreadySentSmsCount : 0;
  const pendingUsersToRespond2 = messagingUsersData ? messagingUsersData.alreadySentSmsCount - messagingUsersData.completedUsers : pendingUsersToRespond1;

  const thereIsNoNewUser = messagingUsersData && messagingUsersData.totalUsers == messagingUsersData.alreadySentSmsCount;

  // The yellow "already received and not responded" banner needs the count
  // of users who got the SMS (smsDate set) AND have NOT yet responded — for
  // both Messages and Text-a-Link share flows. Server-authoritatively that
  // equals `alreadySentSmsCount - completedUsers`, regardless of whether
  // the trivia also has new (not-yet-sent) users selected. The previous
  // formula handled the all-sent and zero-completed cases correctly but
  // returned `totalUsers - alreadySentSmsCount` (the new-not-yet-sent
  // bucket) in mixed scenarios, which mis-stated the banner. All inputs
  // here are server counts — no page-local filters — so pagination is a
  // non-factor. Math.max(0, ...) guards against the rare legacy quirk
  // where completedUsers could exceed alreadySentSmsCount (e.g., a user
  // who completed via a different medium but is also in the SMS cohort).
  const alreadyReceivedSms = messagingUsersData
    ? Math.max(0, (messagingUsersData.alreadySentSmsCount || 0) - (messagingUsersData.completedUsers || 0))
    : 0;


  const numSmsToSend = messagingUsersData && isConfirmNewUsersToSendSms ? messagingUsersData.totalUsers - messagingUsersData.alreadySentMobiles.length : messagingUsersData && messagingUsersData.pendingUsersToRespond ? messagingUsersData.pendingUsersToRespond : showShareconfirm.sms

  const downloadQRCode = () => {
    const canvas = document.querySelector("#qrcode-canvas");
    if (!canvas) throw new Error("<canvas> not found in the DOM");

    toastContainer("QR code downloaded.", "success");

    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    const downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "QR code.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  const refreshTableUsersForMobileNumber = () => {
    const usersOriginal = [...usersListAll];
    const tableUsersRefresh = triviaShareAndPrivacy.sharedWithUsers.map(
      (user) => {
        const findUser = usersOriginal.find(
          (x) =>
            x._id && user.value && x._id.toString() == user.value.toString()
        );
        if (findUser) {
          return {
            ...user,
            mobileNumber: findUser.mobileNumber,
          };
        } else {
          return {
            ...user,
          };
        }
      }
    );

    setTriviaShareAndPrivacy({
      ...triviaShareAndPrivacy,
      sharedWithUsers: tableUsersRefresh,
    });
  };

  const copyQRCode = () => {
    const canvas = document.querySelector("#qrcode-canvas");
    if (!canvas) throw new Error("<canvas> not found in the DOM");

    const ctx = canvas.getContext("2d");
    ctx.fillRect(100, 100, 100, 100);
    ctx.fillStyle = "#eee";
    ctx.fillRect(100, 100, 100, 100);

    //tested on chrome 76
    canvas.toBlob(function (blob) {
      const { ClipboardItem } = window;
      const item = new ClipboardItem({ "image/png": blob });
      navigator.clipboard.write([item]);
    });
  };

  const [allUsersChecked, setAllUsersChecked] = useState(false);
  // Initialize as null (not false) so the BE can distinguish "user did not
  // touch this channel" (null -> skip $set, leave template flag untouched)
  // from "user explicitly chose this channel" (true -> fire branch + $set).
  const [shareTrivvyViaEmail, setShareTrivvyViaEmail] = useState(null);
  const [shareTrivvyViaSMS, setShareTrivvyViaSMS] = useState(null);
  const [shareSlackopen, setShareSlackOpen] = useState(false);
  const [shareTeamsopen, setShareTeamsOpen] = useState(false);
  const [triviaShareAndPrivacy, setTriviaShareAndPrivacy] = useState({
    sharedWithUsers: [],
    privacy: survey.privacy,
  });

  const [userIdentification, setUserIdentification] = useState(
    survey.userIdentificationOptions && survey.userIdentificationOptions[0]
  );


  const [usersListAll, setUsersListAll] = useState([]);

  const [selectedField, setSelectedField] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [usersData, setUsersData] = useState([]);
  const [permissionPopoverOpen, setPermissionPopoverOpen] = useState(false);
  const [duplicateusers, setDuplicateusers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [view, setView] = useState(isMobile ? "MOBILE" : "DESKTOP");
  const [newSelectedUser, setNewSelectedUser] = useState(null);
  const [allMetaData, setAllMetaData] = useState({});
  const [currentFilters, setCurrentFilters] = useState([]);
  const [smsEmailUsersData, setSmsEmailUsersData] = useState({
    smsUserCount: 0,
    totalUsers: 0,
    completedUsers: 0,
    allUsersTakenTrivvy: false,
    alreadySentMobiles: [],
    alreadySentMobilesCount: 0,
    smsUsers: [],
    emailUsers: [],
    sharedWithUsersCount: 0,
    isSharedWithUsersTruncated: false,
  });


  const [newUsersFetchedData, setNewUsersFetchedData] = useState({
    emailUsers: [],
    smsUsers: [],
    totalUsers: 0,
  });


  const [newUsersFetchedDataBackup, setNewUsersFetchedDataBackup] = useState({
    emailUsers: [],
    smsUsers: [],
    totalUsers: 0,
  });

  const [trivvyResults, setTrivvyResults] = useState([]);



  const originalOptions = usersList.filter(
    (x) =>
      !triviaShareAndPrivacy.sharedWithUsers.some((y) => y.value == x.value)
  );

  const togglePermission = () => {
    setPermissionPopoverOpen(!permissionPopoverOpen);
  };

  // const getSmsUsersData = async ()=>{
  //   const response = await axios.get(
  //     `${url.getSmsUserCountForTrivia(survey._id)}?sendToDroppedUsers=YES`
  //   );

  //   const data = (response && response.data && response.data.data) || {};
  //   console.log(data, "✅ SMS user count data");

  //   // Set the count in state
  //   setSmsUsersData((prev) => ({
  //     ...prev,
  //     count: data.smsUserCount,
  //     allUsersTakenTrivvy: data.allUsersTakenTrivvy,
  //     smsUserCount: data.smsUserCount,
  //     alreadySentMobilesCount: data.alreadySentMobilesCount,
  //     alreadySentMobiles: data.alreadySentMobiles || [],
  //   }));

  // }

  const revertOptions = () => {
    setOptions(originalOptions);
    setUsersList(formatSelectedUsers(usersListAll));
    setNewUserRows([{ name: "", mobileNumber: "" }]);
  };

  useEffect(() => {
    if (!survey) return;

    const dateToUse = survey.isMessaging ? survey.createdOn : survey.publishedDate;
    if (!dateToUse) return;

    const handler = setTimeout(() => {
      getMetaData(dateToUse);
    }, 1000); // 1000ms debounce

    return () => {
      clearTimeout(handler); // Clear timeout if any dependency changes
    };
  }, [survey.createdOn, survey.publishedDate, survey.isMessaging]);


  useEffect(() => {
    if (!survey) return;

    if (!skipSharedUsersReset.current) {
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: formatSelectedUsers(survey.sharedWithUsers),
      });
    }

    if (survey.privacy === "ENTERPRISE") {
      setAllUsersChecked(true);
    }

    if (survey.isMessaging && !skipSharedUsersReset.current) {
      if (emailSmsSendModal.type == "SMS_TRIVVY") {
        getTrivvySharedSMSPreview();
      } else {
        getTrivvySharedEmailPreview();
      }
    }
  }, [survey]);

  useEffect(() => {
    if (survey) {
      axios.post(url.getTriviaSubmissions(survey._id)).then(({ data }) => {
        setTrivvyResults(data.data)
      });
    }
  }, [survey]);


  const getMetaData = async (finalDate) => {
    try {

      const response = await axios.get(
        `${url.getOrgUserMetaData}?publishedDate=${encodeURIComponent(
          finalDate
        )}`
      );
      if (response && response.data && response.data.data) {

        let dateArray = [];
        let numberArray = [];
        response.data.data.data.typeInfo.forEach((item) => {
          if (item.isValidFormat) {
            dateArray.push(item.fieldName);
          } else if (item.type === 'number') {
            numberArray.push(item.fieldName)
          }
        });
        setTypesArray({
          dateArray,
          numberArray
        });

        setAllMetaData(response && response.data && response.data.data && response.data.data.data);
      } else {
        console.log("Error fetching metadata: ", response);
      }
    } catch (err) {
      console.log(err, "er");
    }
  };



  const onUserSelect = (u) => {
    setNewSelectedUser(u);
    // const list = [...usersList].filter((x) => x.value != u.value);
    // setUsersList(list);

    if (u && u.mobileNumber && u.mobileNumber.length > 0) {
      let userCellCount = smsUsers + 1;
      setSmsUsers(userCellCount);
    }

    const array = [u, ...triviaShareAndPrivacy.sharedWithUsers];
    if (u) {
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: array,
      });
    }
  };

  const deleteTriviaSharedUsers = async (userIds, usersList) => {
    // tell BE which medium we're removing so users shared via both
    // Text ONLY and Text a Link only lose the medium being deleted, not the
    // whole share record. When there's no active modal type, fall back to the
    // legacy behavior (hard-delete) for safety.
    let shareMedium = null;
    if (emailSmsSendModal && emailSmsSendModal.type === "EMAIL_LINK") {
      shareMedium = "EMAIL";
    } else if (emailSmsSendModal && emailSmsSendModal.type === "SURVEY_LINK") {
      shareMedium = "SMS_LINK";
    } else if (emailSmsSendModal && emailSmsSendModal.type === "SMS_TRIVVY") {
      shareMedium = "SMS";
    }

    const payload = { userIds };
    if (shareMedium) {
      payload.shareMedium = shareMedium;
    }

    const response = await axios.post(url.deleteTriviaSharedUsers(survey._id), payload);

    const deletedIds = typeof userIds === 'string' ? [userIds] : userIds;






    if (usersList.length === 0) {
      if (shareTrivvyViaEmail) {
        getTrivvySharedEmailPreview(pagination.page > 1 ? pagination.page - 1 : pagination.page);
      } else {
        // bug637: pass the current modal type explicitly to insulate the post-delete
        // re-fetch from any future refactor that might change emailSmsSendModal
        // between the delete and this call. Today the modal stays open so the
        // closure would be correct, but making it explicit matches the card-onClick
        // pattern and keeps the medium threading consistent everywhere it matters.
        const activeModalType = emailSmsSendModal && emailSmsSendModal.type;
        getTrivvySharedSMSPreview(
          pagination.page > 1 ? pagination.page - 1 : pagination.page,
          undefined,
          undefined,
          undefined,
          activeModalType
        );
      }
    }



  };




  const removeUser = async (mobileNumber, userId) => {

    const users = [...triviaShareAndPrivacy.sharedWithUsers];
    const newUsers = users.filter((x) => x.userId != userId);

    if (listingType === 'saved') {

      await deleteTriviaSharedUsers(userId, newUsers);


    } else {



      const allIds = [...deletedIds, userId];


      setDeletedIds(allIds);
      setUsersChanged(true);
      console.log(newUsers.length, "✅ New users length after deletion");
      if (newUsers.length === 0) {
        console.log('special condition')
        handleApplyFilters(currentFilters, { page: pagination.page > 1 ? pagination.page - 1 : pagination.page, limit: 10 }, allIds)

      } else {


        await handleApplyFilters(currentFilters, pagination, allIds)
      }


    }


    if (mobileNumber && mobileNumber.length > 0) {
      let userCellCount = smsUsers == 0 ? 0 : smsUsers - 1;

      setSmsUsers(userCellCount);
    }






    if (listingType === 'saved') {



      setSmsEmailUsersData((prev) => ({
        ...prev,
        ...(shareTrivvyViaEmail
          ? { emailUsers: newUsers }
          : { smsUsers: newUsers }),
        totalUsers: prev.totalUsers - 1 > 0 ? prev.totalUsers - 1 : 0,
      }));
      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: [...newUsers],
      });
    }




  };

  const removeDuplicatesUsersByEmailAndMobileNumber = (arr) => {
    const emails = new Set();
    const phoneNumbers = new Set();
    const duplicatesArray = [];

    const filtered = arr.filter((item) => {
      const { email, mobileNumber } = item;
      if (
        (email && emails.has(email)) ||
        (mobileNumber && phoneNumbers.has(mobileNumber))
      ) {
        duplicatesArray.push(item);
        return false; // exclude duplicates (either email or phoneNumber is already seen)
      } else {
        if (email) {
          emails.add(email); // add email to the Set
        }
        if (mobileNumber) {
          phoneNumbers.add(mobileNumber); // add phoneNumber to the Set
        }

        return true; // include unique item
      }
    });

    setDuplicateusers(duplicatesArray);
    emails.clear();
    phoneNumbers.clear();
    return filtered;
  };

  const onUserSelectAll = async (u) => {
    if (u) {

      await handleApplyFilters("", pagination)

    } else {
      setSmsUsers(0);

      setTriviaShareAndPrivacy({
        ...triviaShareAndPrivacy,
        sharedWithUsers: [],
      });

      setDeletedIds([]);


      if (shareTrivvyViaEmail) {
        setNewUsersFetchedData((prev) => ({
          ...prev,
          emailUsers: [],
          totalUsers: 0
        }));
      } else {
        setNewUsersFetchedData((prev) => ({
          ...prev,
          smsUsers: [],
          totalUsers: 0,
        }));
      }

    }
  };

  const formatSelectedUsers = (data) => {
    const d = data.map((e) => {
      if (e.firstName && e.lastName) {
        return {
          label: `${e.firstName}, ${e.lastName}`,
          value: e._id || e.userId,
          permissions: 0,
          profilePic: e.profilePic,
          firstName:
            e.firstName || (e.metaData && e.metaData.firstName) || "Unknown",
          lastName: e.lastName || (e.metaData && e.metaData.lastName),
          date: e.date,
          email: e.email,
          mobileNumber: e.mobileNumber,
          shareMediums: e.shareMediums,
          emailDate: e.emailDate,
          smsDate: e.smsDate,
          isSubmitted: e.isSubmitted,
          userId: e.userId || e._id,
        };
      } else if (e) {
        let name =
          e.firstName && e.firstName.length > 0
            ? e.firstName
            : e.lastName && e.lastName.length > 0
              ? e.lastName
              : e.email;
        return {
          label: `${name}`,
          value: e._id || e.userId,
          permissions: 0,
          firstName:
            e.firstName || (e.metaData && e.metaData.firstName) || "Unknown",
          lastName: e.lastName || (e.metaData && e.metaData.lastName),
          date: e.date,
          email: e.email,
          mobileNumber: e.mobileNumber,
          shareMediums: e.shareMediums,
          emailDate: e.emailDate,
          smsDate: e.smsDate,
          isSubmitted: e.isSubmitted,
          userId: e.userId || e._id,
        };
      }
    });

    return d;
  };

  const getTrivvySharedEmailPreview = async (page, from, sortFieldOverride, sortTypeOverride) => {
    setUsersLoading(true);


    const pageNumber = page || 1;

    const currentSortBy = sortFieldOverride !== undefined ? sortFieldOverride : sortParams.sortBy;
    const currentSortOrder = sortTypeOverride !== undefined ? sortTypeOverride : sortParams.sortOrder;

    let apiUrl = `${url.getTrivvySharedEmailPreview(
      survey._id
    )}?includeMe=true&organizationId=${user.profile.organizationId._id}&page=${pageNumber}&limit=${10}`;

    if (currentSortBy && currentSortOrder) {
      apiUrl += `&sortField=${currentSortBy}&sortType=${currentSortOrder}`;
    }

    await axios
      .get(apiUrl)
      .then((response) => {
        setPagination({
          ...pagination,
          page: pageNumber,
        })
        setUsersLoading(false);



        let arr = response.data.data.emailUsers;

        const {
          totalUsers = 0,
          completedUsers = 0,
          allUsersTakenTrivvy = false,
          emailUsers = [],
          sharedWithUsersCount = 0,
          isSharedWithUsersTruncated = false,
        } = (response.data && response.data.data) || {};

        setSmsEmailUsersData({
          ...smsEmailUsersData,
          totalUsers,
          completedUsers,
          allUsersTakenTrivvy,
          emailUsers,
          sharedWithUsersCount,
          isSharedWithUsersTruncated,
        });
        // Set listing type based on whether there are saved users (only on initial modal open)
        if (listingType === undefined && from === "fromModal") {
          setListingType(totalUsers > 0 ? "saved" : "new");
        }


        setUsersListAll(arr);


        // const arr = [user.profile, ...response.data.data];
        setUsersData(arr);




        // if (privacy == "ENTERPRISE") {
        //   setTriviaShareAndPrivacy({
        //     ...triviaShareAndPrivacy,
        //     privacy: "CUSTOM",
        //     sharedWithUsers: arr,
        //   });
        // } else {
        setTriviaShareAndPrivacy({
          ...triviaShareAndPrivacy,
          sharedWithUsers: arr,
          privacy: survey.privacy,
        });
        // }


        setUsersList(arr);

        setOptions(arr);
      })
      .catch((error) => {
        setUsersLoading(false);
        console.log(error);
      })
      .finally(() => {
        setUsersLoading(false);
      });
  };
  const getTrivvySharedSMSPreview = (page, from, sortFieldOverride, sortTypeOverride, modalTypeOverride) => {
    setUsersLoading(true);

    const pageNumber = page || 1;

    const currentSortBy = sortFieldOverride !== undefined ? sortFieldOverride : sortParams.sortBy;
    const currentSortOrder = sortTypeOverride !== undefined ? sortTypeOverride : sortParams.sortOrder;

    // resolve the active modal type. Card onClicks can't rely on
    // emailSmsSendModal.type because setEmailSmsSendModal is batched and has
    // not landed by the time this call fires, so they pass modalTypeOverride.
    const activeModalType =
      modalTypeOverride !== undefined
        ? modalTypeOverride
        : emailSmsSendModal && emailSmsSendModal.type;

    // Map modal type -> BE shareMedium. SURVEY_LINK is the legacy label for SMS_LINK.
    let shareMediumParam = null;
    if (activeModalType === "SURVEY_LINK" || activeModalType === "SMS_LINK") {
      shareMediumParam = "SMS_LINK";
    } else if (activeModalType === "SMS_TRIVVY" || activeModalType === "SMS") {
      shareMediumParam = "SMS";
    }

    let apiUrl = `${url.getTrivvySharedSMSPreview(
      survey._id
    )}?includeMe=true&organizationId=${user.profile.organizationId._id}&page=${pageNumber}&limit=${10}`;

    if (currentSortBy && currentSortOrder) {
      apiUrl += `&sortField=${currentSortBy}&sortType=${currentSortOrder}`;
    }

    if (shareMediumParam) {
      apiUrl += `&shareMedium=${shareMediumParam}`;
    }

    axios
      .get(apiUrl)
      .then((response) => {
        setPagination({
          ...pagination,
          page: pageNumber
        })
        setUsersLoading(false);
        let arr = [...response.data.data.smsUsers];


        const {
          totalUsers = 0,
          completedUsers = 0,
          allUsersTakenTrivvy = false,
          alreadySentMobiles = [],
          alreadySentMobilesCount = 0,
          smsUserCount = 0,
          smsUsers = [],
          sharedWithUsersCount = 0,
          isSharedWithUsersTruncated = false,
        } = (response.data && response.data.data) || {};

        setSmsEmailUsersData({
          ...smsEmailUsersData,
          smsUserCount,
          totalUsers,
          completedUsers,
          allUsersTakenTrivvy,
          alreadySentMobiles,
          alreadySentMobilesCount,
          smsUsers,

          sharedWithUsersCount,
          isSharedWithUsersTruncated,
        });
        // Set listing type based on whether there are saved users (only on initial modal open)
        if (listingType === undefined && from === "fromModal") {
          setListingType(totalUsers > 0 ? "saved" : "new");
        }


        setUsersListAll(arr);


        // const arr = [user.profile, ...response.data.data];
        setUsersData(arr);






        setSmsUsers(smsUserCount);

        // if (privacy == "ENTERPRISE") {
        //   setTriviaShareAndPrivacy({
        //     ...triviaShareAndPrivacy,
        //     privacy: "CUSTOM",
        //     sharedWithUsers: arr,
        //   });
        // } else {
        setTriviaShareAndPrivacy({
          ...triviaShareAndPrivacy,
          sharedWithUsers: arr,
          privacy: survey.privacy,
        });
        // }

        setUsersList(arr);

        setOptions(arr);
      })
      .catch((error) => {
        setUsersLoading(false);
        console.log(error);
      })
      .finally(() => {
        setUsersLoading(false);
      });
  };


  const handleSocialShare = async (data) => {
    return new Promise((resolve, reject) => {
      const text = `Attend Quiz here - ${survey.name} : ${shareUrl}?medium=slack`;
      let payload = {
        storyText: text,
        attachmentsText: "",
        user: {
          username: data.isAnonymous
            ? "Anonymous"
            : `${user.profile.firstName} ${user.profile.lastName}`,
          text: "",
        },
        entityType: "QUIZ",
        channelId: data.channelId,
        channelName: data.channelName,
        type: data.type,
        workSpaceId: data.workSpaceId,
        teamId: data.teamId,
        tenantId: data.tenantId,
      };

      axios
        .post(url.shareStoryPost, payload)
        .then(({ data }) => {
          toastContainer("Shared successfully", "success");
          resolve(payload.channelId);
        })
        .catch((error) => {
          let message = "Error occured while sending message";
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors &&
            error.response.data.errors.message
          ) {
            message = TRIVVY_SLACK_MEMEBER_MESSAGE;
          }
          toastContainer(message, "error");
          reject(message);
        });
    });
  };

  const showNoChangeAlert = () => {

    if (
      survey &&
      !(listingType === 'new' && usersChanged) &&
      triviaShareAndPrivacy.privacy == survey.privacy &&
      shareTrivvyViaEmail == survey.shareTrivvyViaEmail &&
      shareTrivvyViaSMS === survey.shareTrivvyViaSMS &&
      userIdentification === survey.userIdentificationOptions[0]
    ) {
      let flag = true;
      for (const user of triviaShareAndPrivacy.sharedWithUsers) {
        if (user.shareMediums && user.shareMediums.length == 0) {
          flag = false;
        }

        if (
          isPublishedDateGreaterThanGivenDate(user.emailDate, survey) ||
          isPublishedDateGreaterThanGivenDate(user.smsDate, survey)
        ) {
          flag = false;
        }
      }
      return flag;
    } else {
      return false;
    }
  };

  const saveTrivvyShareUsersApi = async () => {
    try {
      setCurrentFilters([])
      console.log("shareTrivvyViaEmail --", shareTrivvyViaEmail, '---emailSmsSendModal -- ', emailSmsSendModal)

      let shareMedium = emailSmsSendModal && emailSmsSendModal.type ? emailSmsSendModal.type : false

      // Map the FE modal's internal label to the canonical shareMedium value
      // the BE expects: "EMAIL" | "SMS" | "SMS_LINK". Internal identifiers
      // like SURVEY_LINK / SMS_TRIVVY stay as-is in FE state; only the
      // outbound wire value is normalized here.
      let wireType = "SMS"
      if (shareTrivvyViaEmail) {
        wireType = "EMAIL"
      } else if (shareMedium === "SURVEY_LINK") {
        wireType = "SMS_LINK"
      }

      const { data } = await axios.post(
        url.saveTrivvyShareUsersApi(survey._id),
        {
          // sharedWithUsers: users_share, // comment the new users feature as per Arsames
          privacy: triviaShareAndPrivacy.privacy,
          shareTrivvyViaEmail,
          shareTrivvyViaSMS,
          deletedUserIds: deletedIds,
          currentFilters,
          type: wireType,
          dateArray: typesArray.dateArray,
          numberArray: typesArray.numberArray
        }
      );

      setPagination({
        page: 1,
        limit: 10

      })

      const newUsersCount = data && data.data && data.data.newUsers ? data.data.newUsers : 0;
      toastContainer(`${newUsersCount > 0 ? newUsersCount + " " : ""}${newUsersCount === 1 ? "User" : "Users"} saved succesfully!`, "success");
      setDeletedIds((prev) => ([]));

      if (shareTrivvyViaEmail) {

        setSmsEmailUsersData((prev) => ({
          ...prev,
          completedUsers: data.data.completedUsers,
          totalUsers: data.data.totalUsers,
          emailUsers: formatSelectedUsers(data.data.emailUsers),
        }));

      } else {

        setSmsEmailUsersData((prev) => ({
          ...prev,
          allUsersTakenTrivvy: data.data.allUsersTakenTrivvy,
          alreadySentMobiles: data.data.alreadySentMobiles,
          alreadySentMobilesCount: data.data.alreadySentMobilesCount,
          completedUsers: data.data.completedUsers,
          smsUserCount: data.data.smsUserCount,
          totalUsers: data.data.totalUsers,
          smsUsers: formatSelectedUsers(data.data.smsUsers),
        }));
      }

      setNewUsersFetchedData((prev) => ({
        emailUsers: [],
        smsUsers: [],
        totalUsers: 0
      }));

      setNewUsersFetchedDataBackup((prev) => ({
        emailUsers: [],
        smsUsers: [],
        totalUsers: 0,
      }));

      setListingType('saved')

      const response = data.data;


      editCurrentTriviaShareData({
        privacy: triviaShareAndPrivacy.privacy,
        sharedWithUsers:
          shareTrivvyViaEmail
            ? [...response.emailUsers]
            : [...response.smsUsers],
      });

      setUsersChanged(false);

      // setSmsEmailUsersData((prev) => ({
      //   ...prev,
      // });
      // setTriviaShareAndPrivacy({
      //   ...triviaShareAndPrivacy,
      //   sharedWithUsers: formatSelectedUsers(survey.sharedWithUsers),
      // });

      if (shareTrivvyViaEmail) {
        getTrivvySharedEmailPreview(1);
      } else {
        getTrivvySharedSMSPreview(1);
      }
    } catch (err) {
      console.log(err, "err");
      toastContainer("Error while saving users data", "error");
    }
  };

  const callApiToSaveData = (array = [], type = "SENT") => {
    let users_share = array.map((itm, k) => {
      const user = usersListAll.find((x) => x._id == itm.value);

      let sendToUsersAgain = false;
      const mediums = itm.shareMediums || [];

      if (user) {
        // Split the SMS branch by modal type so the persisted per-user
        // shareMediums reflects the actual channel used. Both Text ONLY
        // (SMS_TRIVVY) and Text a Link (SURVEY_LINK) flip shareTrivvyViaSMS
        // to true, so without this split Text a Link would be indistinguishable
        // from Text ONLY in the stored array.
        // "SMS" | "EMAIL" | "SMS_LINK".
        if (user.mobileNumber && shareTrivvyViaSMS) {
          if (emailSmsSendModal.type === "SURVEY_LINK") {
            if (!mediums.includes("SMS_LINK")) {
              mediums.push("SMS_LINK");
            }
          } else {
            if (!mediums.includes("SMS")) {
              mediums.push("SMS");
            }
          }
        }

        if (shareTrivvyViaEmail && !mediums.includes("EMAIL")) {
          mediums.push("EMAIL");
        }

        const updateSMSDate = isPublishedDateGreaterThanGivenDate(
          itm.smsDate,
          survey
        );
        const updateEmailDate = isPublishedDateGreaterThanGivenDate(
          itm.emailDate,
          survey
        );
        const updateDate = isPublishedDateGreaterThanGivenDate(
          itm.date,
          survey
        );

        return {
          firstName:
            user.firstName ||
            (user.metaData && user.metaData.firstName) ||
            "Unknown",
          lastName: user.lastName || (user.metaData && user.metaData.lastName),
          date: itm.date ? itm.date : new Date(),
          genderPronoun: user.genderPronoun,
          profilePic: user.profilePic,
          email: user.email,
          userId: user.userId || user._id,
          mobileNumber: user.mobileNumber,
          shareMediums:
            itm.shareMediums && itm.shareMediums.length > mediums.length
              ? itm.shareMediums
              : mediums,
          emailDate: shareTrivvyViaEmail
            ? itm.emailDate
              ? itm.emailDate
              : new Date()
            : itm.emailDate
              ? itm.emailDate
              : null,
          smsDate: shareTrivvyViaSMS
            ? itm.smsDate
              ? itm.smsDate
              : new Date()
            : itm.smsDate
              ? itm.smsDate
              : null,
          updateSMSDate,
          updateEmailDate,
        };
      } else {
        const userFallback = usersListAll.find((x) => x._id === itm.value);

        return {
          userId: itm.value || itm.userId,
          firstName:
            userFallback && userFallback.firstName
              ? userFallback.firstName
              : (itm && itm.firstName) || "Unknown",
          lastName:
            userFallback && userFallback.lastName
              ? userFallback.lastName
              : (itm && itm.lastName) || "",
          email:
            userFallback && userFallback.email
              ? userFallback.email
              : itm && itm.email,

          mobileNumber:
            userFallback && userFallback.mobileNumber
              ? userFallback.mobileNumber
              : "",
          date: itm.date ? itm.date : new Date(),
          shareMediums: ["EMAIL"],
        };
      }
    });

    const orgObject = user.profile.organizationId;
    const remainingSMS = orgObject.smsLimit - orgObject.totalSmsSent;


    const users_share_sms = users_share.filter((x) =>
      x.shareMediums.includes("SMS")
    );

    if (remainingSMS < users_share_sms.length) {
      let smsCountInc = 0;
      users_share = users_share.map((x) => {
        if (smsCountInc < remainingSMS) {
          if (x.shareMediums.includes("SMS")) {
            smsCountInc += 1;
          }
          return x;
        } else {
          x.shareMediums = ["EMAIL"];
          return x;
        }
      });
    }

    if (
      remainingSMS < users_share_sms.length &&
      !allowSendLimitSMS &&
      emailSmsSendModal.type !== "EMAIL_LINK"
    ) {
      setShowLimitSMSAlert({
        display: true,
        totalSMS: users_share_sms.length,
        remainingLimit: remainingSMS > 0 ? remainingSMS : 0,
      });
      return;
    }

    console.log('1136 NewShare')


    // Keep the top-level `type` aligned with the canonical enum so the BE
    // can route/persist consistently with the per-user shareMediums above.
    // EMAIL | SMS | SMS_LINK — anything else falls back to SMS.
    let wireType = "SMS"
    if (shareTrivvyViaEmail) {
      wireType = "EMAIL"
    } else if (emailSmsSendModal.type === "SURVEY_LINK") {
      wireType = "SMS_LINK"
    }
    const sentDateField = emailSmsSendModal.type === "EMAIL_LINK" ? 'emailDate' : 'smsDate';

    if (survey) {
      axios
        .put(url.sendTrivvyToSharedUsers(survey._id), {
          privacy: triviaShareAndPrivacy.privacy,
          sharedWithUsers: users_share,
          shareTrivvyViaSMS,
          shareTrivvyViaEmail,
          type: wireType,
          isMessaging: survey.isMessaging,
          sendToDroppedUsers: sendToDroppedUsers === "YES",
        })
        .then((res) => {
          setAllowSendLimitSMS(false);
          setShowLimitSMSAlert({
            display: false,
            remainingLimit: 0,
            totalSMS: 0,
          });

          const survey = res.data.data && res.data.data;
          const emailsSent = survey.emailsSentCount;
          const smsSent = survey.smsSentCount;

          if (type == "SENT") {
            if (smsSent) {
              if (props.orgChangeSuccess) {
                props.orgChangeSuccess({
                  totalSmsSent:
                    user.profile.organizationId.totalSmsSent + smsSent,
                });
              }
            }
            if (emailsSent || smsSent) {
              toastContainer(
                `Congrats! Your Trivvy was sent.${emailsSent > 0 ? ` Emails sent - ${emailsSent}` : ""
                }${emailsSent > 0 && smsSent > 0 ? ", " : " "}${smsSent > 0 ? `SMS sent - ${smsSent}` : ""
                }`,
                "success"
              );
            } else {
              toastContainer(`Your Changes were Saved.`, "success");
            }
          } else if (type == "REMOVE") {
            toastContainer("Your Changes were Saved.", "success");
          }

          setNewSelectedUser(null);

          if (survey) {
            if (type == "SENT") {
              skipSharedUsersReset.current = true;
            }
            editCurrentTriviaShareData({
              privacy: survey.privacy,
              sharedWithUsers: [...survey.sharedWithUsers],
              shareTrivvyViaEmail: survey.shareTrivvyViaEmail,
              shareTrivvyViaSMS: survey.shareTrivvyViaSMS,
              firstPublishedDate: survey.firstPublishedDate,
            });

            if (type == "SENT") {
              const sentDate = new Date().toISOString();
              setTriviaShareAndPrivacy((prev) => ({
                ...prev,
                sharedWithUsers: (prev.sharedWithUsers || []).map((user) => {
                  const updated = Object.assign({}, user);
                  updated[sentDateField] = sentDate;
                  return updated;
                }),
              }));
            } else {
              setTriviaShareAndPrivacy((prev) => ({
                ...prev,
                sharedWithUsers: formatSelectedUsers(survey.sharedWithUsers),
              }));
            }
          }
        })
        .catch((error) => {
          setShowLimitSMSAlert({
            display: false,
            remainingLimit: 0,
            totalSMS: 0,
          });
          setNewSelectedUser(null);
          setAllowSendLimitSMS(false);

          const message =
            error.response && error.response.data && error.response.data.errors
              ? error.response.data.errors.message
              : "Error occurred while sharing.";

          toastContainer(message, "error");

          setTriviaShareAndPrivacy({
            privacy: survey.privacy,
            sharedWithUsers: formatSelectedUsers(survey.sharedWithUsers),
          });
          console.log(error);
        });
    }
  };

  const { privacy, sharedWithUsers } = triviaShareAndPrivacy;

  const [isEndDateBeforeToday, setIsEndDateBeforeToday] = useState(false);

  let isSharable = survey.isPublished || (survey.isMessaging == true && survey.otherMediumsShareCount < 1)

  console.log('1283 --- ', isSharable)

  if (isEndDateBeforeToday) {
    isSharable = false;
  }

  let adminRestricted = false;

  if (survey && survey.createdBy && user && user.profile) {
    if (survey && survey.createdBy._id != user.profile._id) {
      adminRestricted = true;
    }

    if (user.profile.orgAdmin || user.profile.role == "Admin") {
      adminRestricted = false;
    }
  }

  useEffect(() => {
    if (survey) {
      if (moment(survey.trivvyEndDate).isBefore(moment())) {
        setIsEndDateBeforeToday(true);
      }

      if (skipSharedUsersReset.current) {
        skipSharedUsersReset.current = false;
      } else {
        setTriviaShareAndPrivacy({
          ...triviaShareAndPrivacy,
          sharedWithUsers:
            emailSmsSendModal.type == "EMAIL_LINK"
              ? smsEmailUsersData.emailUsers
              : smsEmailUsersData.smsUsers,
        });
      }
    }
  }, [survey]);

  const getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  const viewMember = (u) => {
    let link = `/home/${user.profile.organizationId._id}/profile/${u.value}`;
    props.history.push(link);
  };

  const sortComponent = (key) => {
    const handleClick = () => {
      const newOrder = sortParams.sortBy === key && sortParams.sortOrder === "asc" ? "desc" : "asc";
      setSortParams({ sortBy: key, sortOrder: newOrder });

      if (shareTrivvyViaEmail) {
        getTrivvySharedEmailPreview(1, undefined, key, newOrder);
      } else {
        getTrivvySharedSMSPreview(1, undefined, key, newOrder);
      }
    };

    return (
      <span
        onClick={handleClick}
        style={{ cursor: "pointer", marginLeft: "5px" }}
      >
        {sortParams.sortBy === key && sortParams.sortOrder === "asc" ? (
          <BiDownArrowAlt size={"18px"} />
        ) : (
          <BiUpArrowAlt size={"18px"} />
        )}
      </span>
    );
  };

  const tableCols = {
    user: survey && survey.isMessaging == true ? 4 : 2,
    date: 2,
    action: 1,
    phoneNumber: survey && survey.isMessaging == true ? 3 : shareTrivvyViaSMS ? 2 : 0,
    email: shareTrivvyViaEmail ? 3 : 0,
    sharedVia: 2,
    dateSent: 2
  };

  const planInvalid =
    user.profile && user.profile.organizationId
      ? ["001", "002"].includes(user.profile.organizationId.trivvyPlanType)
      : false;

  // const planInvalidSms = // commenting it now as per Arsames
  //   user.profile && user.profile.organizationId
  //     ? ["001"].includes(user.profile.organizationId.trivvyPlanType)
  //     : false;

  const shareMediumDisabled = () => {
    if (survey) {
      if (triviaShareAndPrivacy.privacy == "PUBLIC") {
        return false;
      } else {
        if (triviaShareAndPrivacy.privacy == "CUSTOM") {
          return false;
        }
        if (survey.privacy != triviaShareAndPrivacy.privacy) {
          return false;
        } else {
          return true;
        }
      }
    } else {
      return true;
    }
  };

  const handleClickShareButton = async (shareConfirmed) => {
    console.log('1318 --- ', shareConfirmed)
    if (shareConfirmed) {
      console.log('testing 1320')
      callApiToSaveData(triviaShareAndPrivacy.sharedWithUsers, "SENT");
    } else {
      let emailsCounts = 0;
      let smsCounts = 0;
      let allUsersTakenTrivvy = false;
      let pendingUsersToRespond = 0;
      let showResendOption = false;
      console.log('testing 1325')
      console.log('shareTrivvyViaEmail -- ', shareTrivvyViaEmail)
      console.log('shareTrivvyViaSMS -- ', shareTrivvyViaSMS)

      if (shareTrivvyViaEmail) {
        try {
          const response = await axios.get(
            url.getEmailEligibleUserCount(survey._id)
          );
          emailsCounts = response.data.data.totalUsers - response.data.data.completedUsers;
          allUsersTakenTrivvy = response.data.data.allUsersTakenTrivvy || false;
          pendingUsersToRespond = response.data.data.alreadySentEmailsCount - response.data.data.completedUsers;
          showResendOption = pendingUsersToRespond > 0;
        } catch (error) {
          console.log(error);
        }
      }

      if (shareTrivvyViaSMS) {
        try {
          const response = await axios.get(
            `${url.getSmsUserCountForTrivia(survey._id)}?sendToDroppedUsers=YES`
          );
          smsCounts = response.data.data.smsUserCount;
        } catch (error) {
          console.log(error);
        }
      }
      setShowShareConfirm({
        display: true,
        emails: emailsCounts,
        sms: smsCounts,
        allUsersTakenTrivvy: allUsersTakenTrivvy,
        showResendOption: showResendOption,
        pendingUsersToRespond: pendingUsersToRespond
      });
    }
  };

  const saveSharedConfig = () => {
    if (usersChanged) {
      return false;
    } else if (triviaShareAndPrivacy.privacy != survey.privacy) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (allowSendLimitSMS == true) {
      callApiToSaveData(triviaShareAndPrivacy.sharedWithUsers, "SENT");
    }
  }, [allowSendLimitSMS]);

  const handleApplyFilters = async (filters, pagination, allDeletedIds = []) => {
    const paginationData = pagination || { page: 1, limit: 10 };

    setUsersLoading(true);
    setCurrentFilters(filters);

    // Parse filters string into normalized JSON format for exact matching (no regex on backend)
    let normalizedFilters = [];
    if (filters && typeof filters === 'string' && filters.length > 0) {
      // Decode the entire filter string first (may be double-encoded)
      let decodedFilters = decodeURIComponent(filters);
      try {
        decodedFilters = decodeURIComponent(decodedFilters);
      } catch (e) {
        // Already fully decoded
      }

      // Now split by & to get individual filter pairs. Group values by key
      // so multiple repeated `filters[<key>]=...` pairs collapse into a single
      // `{ key, values: [...] }` entry — this is what enables OR semantics on
      // the BE when the user picks multiple Search Values for one field.
      const filterPairs = decodedFilters.split('&');
      const grouped = {};
      filterPairs.forEach(pair => {
        const match = pair.match(/(?:filters\[([^\]]+)\]|([^=]+))=(.+)/);
        if (match) {
          const key = (match[1] || match[2]).trim();
          const value = match[3];
          if (!grouped[key]) grouped[key] = [];
          value.split(',').forEach(v => grouped[key].push(v.trim()));
        }
      });
      normalizedFilters = Object.keys(grouped).map(key => ({
        key,
        values: grouped[key],
      }));
    }

    // Map the modal's internal type to the BE-canonical share medium so the
    // user-list query can distinguish "Text ONLY" (SMS) from "Text a Link"
    // (SMS_LINK) when computing the alreadyShared set. Without this the FE
    // would always send "SMS" and the BE would mark a user already shared
    // via "Text ONLY" as already shared in the "Text a Link" modal too.
    let listType = "SMS";
    if (shareTrivvyViaEmail) {
      listType = "EMAIL";
    } else if (
      emailSmsSendModal &&
      (emailSmsSendModal.type === "SURVEY_LINK" || emailSmsSendModal.type === "SMS_LINK")
    ) {
      listType = "SMS_LINK";
    }

    axios
      .get(
        url.userListArray +
        `?includeMe=true&triviaId=${survey._id}&type=${listType}` +
        `&page=${paginationData.page}&limit=${paginationData.limit}` +
        `&filters=${encodeURIComponent(JSON.stringify(normalizedFilters))}` +
        `&deletedIds=${Array.isArray(allDeletedIds) && allDeletedIds.length > 0 ? allDeletedIds.join(",") : ""}` +
        `&dateArray=${typesArray && Array.isArray(typesArray.dateArray) && typesArray.dateArray.length > 0 ? typesArray.dateArray.join(",") : ""}` +
        `&numberArray=${typesArray && Array.isArray(typesArray.numberArray) && typesArray.numberArray.length > 0 ? typesArray.numberArray.join(",") : ""}`
      )
      .then((response) => {
        setUsersLoading(false);
        setHasSearched(true);

        let arr = shareTrivvyViaEmail
          ? [...response.data.data.emailUsers]
          : [...response.data.data.smsUsers];

        arr = arr.filter((value) => !allDeletedIds.includes(value._id));

        if (!(response.data.data.totalUsers > 0) && allDeletedIds.length === 0) {

          if (response.data.data.alreadyRespondedCount > 0) {
            toastContainer(
              `${response.data.data.alreadyRespondedCount} user(s) have already responded to this Trivvy and can not receive it again.`,
              "error"
            );
          } else {
            toastContainer(
              'No users match your current filters. This may be because they are missing the required contact info for this sharing method, or they have already been selected (see "Already Saved").',
              "error"
            );
          }
        }


        if (response.data && response.data.data && response.data.data.alreadyRespondedCount > 0) {
          toastContainer(
            `${response.data.data.alreadyRespondedCount} user(s) have already responded to this Trivvy and can not receive it again.`,
            "error"
          );
        }

        setUsersChanged(true);

        setPagination({
          limit: response.data.data.limit,
          page: response.data.data.page,
        });

        setNewUsersFetchedData((prev) => ({
          ...prev,
          totalUsers: response.data.data.totalUsers,
          ...(shareTrivvyViaEmail
            ? { emailUsers: response.data.data.emailUsers }
            : { smsUsers: response.data.data.smsUsers }),
        }));
        setNewUsersFetchedDataBackup((prev) => ({
          ...prev,
          totalUsers: response.data.data.totalUsers,
          ...(shareTrivvyViaEmail
            ? { emailUsers: response.data.data.emailUsers }
            : { smsUsers: response.data.data.smsUsers }),
        }));

        arr = formatSelectedUsers(arr);

        setTriviaShareAndPrivacy((old) => ({
          ...old,
          sharedWithUsers: arr,
        }));

      })
      .catch((error) => {
        setUsersLoading(false);
        console.log(error);
      })
      .finally(() => {
        setUsersLoading(false);
      });
  };


  const getOptions = async (inputValue, callback) => {
    if (inputValue) {
      return axios
        .post(`${url.userListArrayForTrivvyShare}`, {
          triviaId: surveyId,
          text: inputValue,
        })
        .then(({ data }) => {
          const searchedList = formatSelectedUsers(data.data);
          const usersSearched = searchedList.filter(
            (x) => !sharedWithUsers.some((y) => y.value == x.value)
          );

          setUsersList(usersSearched);

          if (usersSearched.length == 0) {
            if (isNaN(inputValue)) {
              setNewUserRows([{ ...newUserRows[0], name: inputValue }]);
            } else {
              setNewUserRows([{ ...newUserRows[0], mobileNumber: inputValue }]);
            }
          }
          return {
            options: shareTrivvyViaSMS
              ? usersSearched.filter((x) => x.mobileNumber)
              : usersSearched,
            // options: usersSearched,
          };
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      return {
        // options: usersList,
        options: shareTrivvyViaSMS
          ? usersList.filter((x) => x.mobileNumber)
          : usersList,
      };
    }
  };

  const resetNumbers = () => {
    setNewUsersFetchedData({
      totalUsers: 0,
      smsUsers: [],
      emailUsers: []
    });
    setSmsEmailUsersData({
      smsUserCount: 0,
      totalUsers: 0,
      completedUsers: 0,
      allUsersTakenTrivvy: false,
      alreadySentMobiles: [],
      alreadySentMobilesCount: 0,
      smsUsers: [],
      emailUsers: [],
      sharedWithUsersCount: 0,
      isSharedWithUsersTruncated: false,
    });
    setTriviaShareAndPrivacy((prev) => ({
      ...prev,
      sharedWithUsers: []
    }));
    setAllUsersChecked(false);
  }

  const handleMessagingUserCount = async () => {
    try {
      const response = await axios.get(
        url.getMessagingUserCountForTrivia(survey._id)
      );

      const data = response && response.data && response.data.data || {};
      setMessagingUsersData(data);

      if (data.pendingUsersToRespond > 0) {
        setDisplayPendingToSendAlert(true);
      }
      const newUsersCount = data && data.totalUsers > data.alreadySentMobiles.length ? true : false;
      if (newUsersCount) {
        setNewUsersToSendSms(true);
      } else setNewUsersToSendSms(false);
      setIsConfirmNewUsersToSendSms(false)
    } catch (error) {
      console.error("❌ Error fetching messaging user count:", error);
    }
  };

  const handleSendEmail = () => {
    console.log(' handleSendEmail');
    toastContainer("setup email sending API.", "success");
  };
  const handleSendSMS = (confirmed = false) => {
    console.log('confirmed --- 1525 -- ', confirmed)
    console.log("emailSmsSendModal.type  --- ", emailSmsSendModal.type)

    // Route to the right endpoint and tag the payload with the canonical
    // shareMedium so the BE can persist/route consistently: Text a Link ->
    // "SMS_LINK", Messages Text ONLY -> "SMS".
    let postURL = url.resendIsMessagingTrivvyToUsers
    let shareMediums = ["SMS"]
    if (emailSmsSendModal.type === "SURVEY_LINK") {
      postURL = url.sendTrivvyLinkAsTxt
      shareMediums = ["SMS_LINK"]
    }


    console.log('1497 -----')
    if (confirmed) {
      axios
        .post(postURL, {
          triviaId: survey._id,
          sendToDroppedUsers: sendToDroppedUsers === "YES",
          shareMediums,
        })
        .then(({ data }) => {
          console.log("NO text sent:", data)

          if (data.data.updateTrivvyUsers) {
            setCurrentTrivia({
              ...survey,
              sharedWithUsers: [...data.data.updateTrivvyUsers.sharedWithUsers],
            })
          }
          const smsSentDate = new Date().toISOString();
          setTriviaShareAndPrivacy((prev) => ({
            ...prev,
            sharedWithUsers: (prev.sharedWithUsers || []).map((user) => {
              const updated = Object.assign({}, user);
              updated.smsDate = smsSentDate;
              return updated;
            }),
          }));
          if (data.data.totalSent) {
            toastContainer(`Sent ${data.data.totalSent} text message${data.data.totalSent > 1 ? 's' : ''} successfully`, 'success');
          } else {
            toastContainer('No text message was sent.', 'success')
          }
        })
        .catch((err) => {
          toastContainer('Error while sending message', 'error')
        })

    }
    setShowShareConfirm({
      display: true,
      emails: 0,
      sms: smsEmailUsersData.totalUsers,
    });
  }

  // const disabledSendButton = () => {
  //   if (
  //     survey &&
  //     survey.sharedWithUsers &&
  //     Array.isArray(survey.sharedWithUsers)
  //   ) {
  //     const notSentUser = survey.sharedWithUsers.find(
  //       (x) => x.mobileNumber && !x.smsDate
  //     )

  //     debugger
  //     if (notSentUser) {
  //       return false
  //     }
  //   }

  //   return true
  // }

  const addNewRowUserToShareTable = (index) => {
    const newUsersArr = [...newUserRows];

    const newUserObject = newUsersArr[0];

    if (shareTrivvyViaEmail && newUserObject.email) {
      const userExists = usersListAll.find(
        (x) => x.email == newUserObject.email.toLowerCase()
      );
      if (userExists) {
        toastContainer("User already exists", "error");
      }
    }
    if (shareTrivvyViaSMS && newUserObject.mobileNumber) {
      const userExists = usersListAll.find(
        (x) => x.mobileNumber == newUserObject.mobileNumber
      );
      if (userExists) {
        toastContainer("User already exists", "error");
      }
    }

    const sharedUsers = [];

    const formatObject = {
      ...(newUserObject.name && {
        firstName: newUserObject.name.split(" ")[0],
        lastName: newUserObject.name.split(" ")[1],
      }),
      mobileNumber: newUserObject.mobileNumber,
      email: newUserObject.email,
      userId: newUserObject.userId || newUserObject._id,
    };

    sharedUsers.push(formatObject);

    setTriviaShareAndPrivacy({
      ...triviaShareAndPrivacy,
      sharedWithUsers: removeDuplicatesUsersByEmailAndMobileNumber([
        ...triviaShareAndPrivacy.sharedWithUsers,
        ...sharedUsers,
      ]),
    });

    revertOptions();
  };

  const toCamelCase = (str) =>
    str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) =>
        index === 0 ? word.toLowerCase() : word.toUpperCase()
      )
      .replace(/\s+/g, "")
      .replace(/[^a-zA-Z0-9]/g, "");

  // Build field options from typeInfo
  const fieldOptions =
    allMetaData &&
    allMetaData.typeInfo &&
    allMetaData.typeInfo.map(function (field) {
      return {
        label: toCamelCase(field.fieldName),
        value: field.fieldName,
      };
    });

  // Get value options based on selected field
  const valueOptions =
    selectedField &&
    allMetaData &&
    allMetaData.columnMetadata &&
    allMetaData.columnMetadata[selectedField.value] &&
    allMetaData.columnMetadata[selectedField.value].map(function (val) {
      return {
        label: val.toString(),
        value: val,
      };
    });

  console.log(triviaShareAndPrivacy, "triviaShareAndPrivacy");



  // ─── Derived flags ────────────────────────────────────────────────
  var isSavedListing = listingType === "saved";
  var hasScheduledDate = survey && survey.scheduledDate ? true : false



  var isSmsTrivvy =
    emailSmsSendModal && emailSmsSendModal.type === "SMS_TRIVVY";


  var isCustomPrivacyWithoutUsers =
    triviaShareAndPrivacy &&
    triviaShareAndPrivacy.privacy === "CUSTOM" &&
    triviaShareAndPrivacy.sharedWithUsers &&
    triviaShareAndPrivacy.sharedWithUsers.length === 0;

  var isShareButtonDisabled =
    !isSharable ||
    showNoChangeAlert() ||
    isCustomPrivacyWithoutUsers ||
    (!shareTrivvyViaEmail && !shareTrivvyViaSMS);

  var formattedScheduledDate =
    hasScheduledDate &&
    moment(survey.scheduledDate).format("MMM DD, YYYY [at] hh:mm A");


  const isScheduledDateInPast =
    hasScheduledDate &&
      survey &&
      moment().isAfter(moment(survey.scheduledDate)) ? hasScheduledDate &&
      survey &&
    moment().isAfter(moment(survey.scheduledDate)) : false


  // var canRenderActions =
  // isSavedListing &&
  // (hasScheduledDate && isScheduledDateInPast) && // if scheduled, don't show action buttons
  // survey &&
  // survey.isMessaging == true &&
  // survey.sharedWithUsers &&
  // survey.sharedWithUsers.length > 0;

  const canRenderActions =
    isSavedListing &&
    survey &&
    survey.isMessaging === true &&
    survey.sharedWithUsers &&
    survey.sharedWithUsers.length > 0 &&
    (
      !hasScheduledDate ||      // no scheduled date
      isScheduledDateInPast     // OR scheduled date already passed
    );

  console.log('hasScheduledDate -- ', hasScheduledDate)
  console.log('isScheduledDateInPast -- ', isScheduledDateInPast)


  const formatUserListForExport = (surveyList, isMessaging) => {
    return surveyList.map((item) => ({
      name: `${item.firstName || ''} ${item.lastName || ''}`.trim() || '',
      email: item.email || '',
      mobileNumber: item.mobileNumber || '',
      sendtDate: item.smsDate
        ? moment(item.smsDate).format('MMM D, YYYY [at] h:mma')
        : '',
      ...(isMessaging ? {} : {
        completedDate: item.isSubmittedDate
          ? moment(item.isSubmittedDate).format('MMM D, YYYY [at] h:mma')
          : '',
      }),
    }));
  };

  const getDataForExportResult = async () => {
    const response = await axios.get(
      `${url.getTrivvySharedEmailPreview(
        survey._id
      )}?includeMe=true&organizationId=${user.profile.organizationId._id}`
    );
    const surveyList = response.data.data.emailUsers || [];
    return formatUserListForExport(surveyList, survey.isMessaging);
  }

  const getSMSDataForExportResult = async () => {
    const response = await axios.get(
      `${url.getTrivvySharedSMSPreview(
        survey._id
      )}?includeMe=true&organizationId=${user.profile.organizationId._id}`
    );
    const surveyList = response.data.data.smsUsers || [];
    return formatUserListForExport(surveyList, survey.isMessaging);
  }


  const csv_headers = [
    {
      label: 'User',
      key: 'name',
    },
    {
      label: 'Email',
      key: 'email',
    },
    {
      label: 'Mobile Number',
      key: 'mobileNumber',
    },
    {
      label: 'Sent Date',
      key: 'sendtDate',
    },
    ...(survey.isMessaging ? [] : [{
      label: 'Response Date',
      key: 'completedDate',
    }]),
  ]


  const tableUI = (

    <div>
      <div className={`mt-4 share-trivia-invite-wrapper`}>
        <div className="dFelxCenterWithGap justify-content-between">
          {" "}
          <h5>Select Users to Share This Trivvy</h5>{" "}
        </div>
        <div className={`my-1 share-quiz-privacy`}>
          <FormGroup
            className={
              isOwner
                ? "disabled-change-permission mt40 share-quiz-privacy-form-css"
                : "mt40 share-quiz-privacy-form-css"
            }
            row
          >
            {listingType === "new" && (
              <>
                <Col sm={12} md={12} lg={12}>
                  <span
                    className="enterprise-setting-label"
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    {allUsersChecked ? "Deselect to remove" : "Select"}{" "}
                    all users{" "}
                  </span>
                  <CheckBox
                    // disabled={planInvalidSms}
                    checked={allUsersChecked}
                    onChange={async (e) => {
                      setAllUsersChecked(!allUsersChecked);
                      await onUserSelectAll(!allUsersChecked);

                      setUsersChanged(true);
                    }}
                  />
                </Col>

                <Col
                  style={{
                    marginTop: "10px",
                  }}
                >
                  <FilterSelector
                    allMetaData={allMetaData}
                    trivvyType={survey.isMessaging == true ? "messages" : "surveys"}
                    shareType={emailSmsSendModal.type}
                    handleApplyFilters={(filters) => {
                      setDeletedIds((prev) => ([]));

                      handleApplyFilters(filters);
                    }}
                  />
                </Col>
              </>
            )}
            <Col sm={12} md={12} lg={12}>
              <div
                style={{
                  display: "flex",
                  gap: "20px",
                  alignItems: "center",
                  margin: "10px 0",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", gap: "15px" }}>
                  <label>
                    <input
                      type="radio"
                      disabled={usersLoading}
                      name="userViewRadio"
                      value="new"
                      checked={listingType === "new"}
                      onChange={() => {
                        setDisplayPendingToSendAlert(false);
                        setShowDroppedUsersAlert(false);
                        setShowShareConfirm({
                          display: false,
                          sms: 0,
                          emails: 0,
                        });
                        setListingType("new");
                        setHasSearched(false);
                        setPagination({
                          page: 1,
                          limit: 10,
                        })

                        if (currentFilters.length > 0) {

                          handleApplyFilters(currentFilters, { page: 1, limit: 10 }, deletedIds);
                        } else {
                          setTriviaShareAndPrivacy((prev) => ({
                            ...prev,
                            sharedWithUsers: shareTrivvyViaEmail
                              ? newUsersFetchedData.emailUsers
                              : newUsersFetchedData.smsUsers,
                          }));
                        }
                      }}
                    />{" "}
                    New Users
                  </label>
                  <label>
                    <input
                      disabled={usersLoading}
                      type="radio"
                      name="userViewRadio"
                      value="shared"
                      checked={listingType === "saved"}
                      onChange={() => {
                        setCurrentFilters([])
                        setListingType("saved");
                        setPagination({
                          page: 1,
                          limit: 10,
                        })
                        if (shareTrivvyViaEmail) {
                          getTrivvySharedEmailPreview(1);
                        } else {
                          getTrivvySharedSMSPreview(1);
                        }
                      }}
                    />{" "}
                    Already Saved
                  </label>
                </div>


                {
                  listingType !== "new" && <div style={{ marginTop: '-12px' }}>
                    <CSVLink
                      data={[]}
                      headers={csv_headers}
                      filename={`Trivvys-${moment().format('MM/DD/YYYY')}.csv`}
                      separator={','}
                      target="_blank"
                      onClick={async (e) => {
                        e.preventDefault();
                        e.currentTarget.blur();
                        let csvData = [];
                        if (emailSmsSendModal.type == "EMAIL_LINK") {
                          csvData = await getDataForExportResult();
                        } else {
                          csvData = await getSMSDataForExportResult();
                        }

                        downloadCSV(csvData, csv_headers, `Trivvys-${moment().format('MM/DD/YYYY')}.csv`);
                      }}
                      className="mr-4 btn trivia-action-button-main trivvy-list-export-mobile trivvy-export-table-btn">
                      {'Export to CSV'} <BsDownload size={13} />
                    </CSVLink>
                  </div>
                }



              </div>
            </Col>

            <Col sm={12} md={12} lg={12}>
              <div className="show_shared_trivvy_users">
                <div className="shareTableTrivia">
                  {!isMobile && (
                    <LayoutRow className="mobileNoheightActionTable">
                      <LayoutHeading
                        className="border justify-content-center bg-white"
                        colWidth={tableCols.user}
                        plainTable
                      >
                        <span style={{ marginLeft: '38px', display: 'flex', alignItems: 'center' }}>
                          User
                          {listingType === "saved" && sortComponent("user")}
                        </span>

                      </LayoutHeading>
                      {shareTrivvyViaSMS ? (
                        <LayoutHeading
                          className="border justify-content-center bg-white"
                          colWidth={tableCols.phoneNumber}
                          plainTable
                        >
                          <span style={{ marginLeft: '8px', display: 'flex', alignItems: 'center' }}>
                            Mobile Number
                            {listingType === "saved" && sortComponent("mobileNumber")}
                          </span>

                        </LayoutHeading>
                      ) : null}

                      {shareTrivvyViaEmail ? (
                        <LayoutHeading
                          className="border justify-content-center bg-white"
                          colWidth={tableCols.email}
                          plainTable
                        >
                          <span style={{ marginLeft: '64px', display: 'flex', alignItems: 'center' }}>
                            Email
                            {listingType === "saved" && sortComponent("email")}
                          </span>

                        </LayoutHeading>
                      ) : null}



                      {/* <LayoutHeading
                          className="border justify-content-center bg-white"
                          colWidth={tableCols.sharedVia}
                          plainTable
                        >
                          Shared Date
                        </LayoutHeading> */}


                      <LayoutHeading
                        className="border justify-content-center bg-white"
                        colWidth={tableCols.dateSent}
                        plainTable
                      >
                        <span style={{ marginLeft: '16px', display: 'flex', alignItems: 'center' }}>
                          Sent Date
                          {listingType === "saved" && sortComponent(survey && survey.isMessaging ? "smsDate" : (shareTrivvyViaEmail ? "emailDate" : "smsDate"))}
                        </span>

                      </LayoutHeading>

                      {survey && survey.isMessaging != true ? <LayoutHeading
                        className="border justify-content-center bg-white"
                        colWidth={tableCols.sharedVia}
                        plainTable
                      >
                        <span style={{ marginLeft: '-5px', display: 'flex', alignItems: 'center' }}>
                          Response Date
                          {listingType === "saved" && sortComponent("isSubmittedDate")}
                        </span>

                      </LayoutHeading>
                        : null}




                      <LayoutHeading
                        className="border justify-content-center bg-white"
                        colWidth={tableCols.action}
                        plainTable
                      >
                        <span style={{ marginLeft: '-14px' }}>
                          Action
                        </span>


                      </LayoutHeading>
                    </LayoutRow>
                  )}

                  <div
                    style={{
                      overflowY: "auto",
                      overflowX: "hidden",
                      marginLeft: "-15px",
                    }}
                    className="hide-scroll w1scr"
                  >
                    <PaginatedUserList
                      usersLoading={usersLoading}
                      hasSearched={hasSearched}
                      listingType={listingType}
                      sharedWithUsers={
                        listingType === "new"
                          ? (shareTrivvyViaEmail
                            ? formatSelectedUsers(newUsersFetchedData.emailUsers)
                            : formatSelectedUsers(newUsersFetchedData.smsUsers))
                          : sharedWithUsers
                      }
                      isMobile={isMobile}
                      tableCols={tableCols}
                      survey={survey}
                      shareTrivvyViaSMS={shareTrivvyViaSMS}
                      shareTrivvyViaEmail={shareTrivvyViaEmail}
                      user={user}
                      profilePicValidityCheck={profilePicValidityCheck}
                      getInitials={getInitials}
                      removeUser={removeUser}
                      viewMember={viewMember}
                      listingType={listingType}
                      totalUsers={
                        listingType === "new"
                          ? newUsersFetchedData.totalUsers
                          : smsEmailUsersData.totalUsers
                      }
                      limit={pagination.limit}
                      page={pagination.page}
                      trivvyResults={trivvyResults}
                      handlePageChange={(page) => {
                        if (listingType === "new") {
                          handleApplyFilters(currentFilters, {
                            page,
                            limit: pagination.limit,
                          });
                        } else {
                          if (shareTrivvyViaEmail) {
                            getTrivvySharedEmailPreview(page);
                          } else {
                            getTrivvySharedSMSPreview(page);
                          }
                        }
                      }}
                      emailSmsSendModal={emailSmsSendModal}
                    />
                  </div>
                  {!usersLoading ? (
                    <Row className="mr-0 px-0">

                    </Row>
                  ) : (
                    <div className="text-center">Loading...</div>
                  )}
                  {listingType === "new"
                    ? newUsersFetchedData.totalUsers > 0 && (
                      <div className="text-center">
                        Total Users : {newUsersFetchedData.totalUsers}
                      </div>
                    )
                    : smsEmailUsersData.totalUsers > 0 && (
                      <div className="text-center">
                        Total Users : {smsEmailUsersData.totalUsers}
                      </div>
                    )}


                </div>
              </div>
            </Col>
          </FormGroup>
        </div>
      </div>
      {listingType === "new" && (
        <div>
          {survey && (
            <Button
              className="trivia-action-button-main-reverse share-via-trivvy-button mt-3 mb-4"
              disabled={
                shareTrivvyViaEmail
                  ? newUsersFetchedData.emailUsers.length === 0
                  : newUsersFetchedData.smsUsers.length === 0
              }
              onClick={saveTrivvyShareUsersApi}
            >
              Save users
            </Button>
          )}

        </div>
      )}
      {isSavedListing &&
        hasScheduledDate &&
        isScheduledDateInPast != true &&
        survey && (
          <div className="mt-3">
            <Button className="trivia-edit-btn-height mb-1 trivvy-scheduledBtn">
              {isScheduledDateInPast ? "Sent on " : "Scheduled for "}
              {formattedScheduledDate}
            </Button>
            <div>
              <small className="text-muted">
                {survey.isMessaging
                  ? "To reschedule or send now, please go back to the Edit tab."
                  : "To reschedule or send now, please unpublish and go to Advanced Settings."}
              </small>
            </div>
          </div>
        )}

      {/* Actions when listing is "saved", NOT scheduled, and messaging == true */}
      {canRenderActions && (
        <div className="mt-3 d-flex justify-content-end">
          {isSmsTrivvy ? (
            <>
              {!showDroppedUsersAlert ? (
                <Button
                  color="success"
                  className="trivia-edit-btn-height mb-2"
                  onClick={function () {
                    handleSendSMS(false);
                    setShowDroppedUsersAlert(true)
                    handleMessagingUserCount();
                  }}
                  disabled={!sharedWithUsers || sharedWithUsers.length === 0}
                >
                  Share Trivvy as SMS Texts
                  <MdOutlineMobileFriendly className="ml-1" />
                </Button>
              ) : null}
            </>
          ) : (
            <Button
              disabled={isShareButtonDisabled || (shareTrivvyViaEmail && smsEmailUsersData.emailUsers.length === 0)}
              onClick={function () {
                handleClickShareButton(false);
              }}
              className="share-via-trivvy-button trivia-action-button-main mr-2 mt-2"
            >
              Share Trivvy Link
            </Button>
          )}
        </div>
      )}
    </div>
  );

  const TrivvyNote = () => {
    return <span>
      To share a Trivvy with users on this platform, you first need to go to the "Users List" <img style={{ height: '10px', marginTop: '-3.5px', paddingLeft: '1.5px' }} src={privacyIcon} /> on the top right corner of your screen and upload a file or invite them. Then come back here to share the Trivvy with them.
    </span>
  }

  const Note = () => {
    return <div className="d-flex flex-column">
      <TrivvyNote />
      <span className="pt-2">Otherwise, go back to the last screen and share in other ways.</span>
    </div>
  }


  const PlatformSharing = () => (
    <div className="d-flex flex-column">
      <TrivvyNote />
      <span className="pt-2">Otherwise, select one of the Other Ways below.</span>
    </div>
  );

  return (
    <div className="trivia_share_page">
      {shareTeamsopen && (
        <TeamsSharePopup
          handleSocialShare={handleSocialShare}
          teamsShared={[]}
          answer={""}
          orgId={user.profile.organizationId._id}
          userId={user.profile._id}
          setShowTeamsPopup={(val) => setShareTeamsOpen(val)}
          organization={user.profile.organizationId}
        />
      )}

      <div
        style={{
          display: "none",
        }}
      >
        <QRCodeCanvas
          id="qrcode-canvas"
          level="H"
          size={100}
          value={shareUrl + "?medium=qrcode"}
        />
      </div>

      {shareSlackopen && (
        <SlackSharePopup
          handleSocialShare={handleSocialShare}
          slackShared={[]}
          answer={""}
          orgId={user.profile.organizationId._id}
          userId={user.profile._id}
          setShowSlackPopup={(val) => setShareSlackOpen(val)}
          organization={user.profile.organizationId}
        />
      )}
      <Row
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Col sm={9} className="">

          <div className="py-4"></div>

          {isEndDateBeforeToday ? (
            <Alert className="mt-4" color="primary">
              <b>
                The end date needs to be updated before sharing this Trivvy.
              </b>
            </Alert>
          ) : (
            ""
          )}

          {survey.isMessaging ? (
            <MessagesSharingOptions
              isSharable={isSharable}
              resetNumbers={resetNumbers}
              getTrivvySharedSMSPreview={getTrivvySharedSMSPreview}
              getTrivvySharedEmailPreview={getTrivvySharedEmailPreview}
              setShareTrivvyViaEmail={setShareTrivvyViaEmail}
              setShareTrivvyViaSMS={setShareTrivvyViaSMS}
              setEmailSmsSendModal={setEmailSmsSendModal}
              shareUrl={shareUrl}
              downloadQRCode={downloadQRCode}
              isMobile={isMobile}
              copySurveyUrl={copySurveyUrl}
              PlatformSharing={PlatformSharing}
            />
          ) : (
            <TrivvySharingOptions
              isSharable={isSharable}
              resetNumbers={resetNumbers}
              getTrivvySharedSMSPreview={getTrivvySharedSMSPreview}
              getTrivvySharedEmailPreview={getTrivvySharedEmailPreview}
              setShareTrivvyViaEmail={setShareTrivvyViaEmail}
              setShareTrivvyViaSMS={setShareTrivvyViaSMS}
              setEmailSmsSendModal={setEmailSmsSendModal}
              shareUrl={shareUrl}
              downloadQRCode={downloadQRCode}
              isMobile={isMobile}
              copySurveyUrl={copySurveyUrl}
              PlatformSharing={PlatformSharing}
            />
          )}


          <Modal isOpen={emailSmsSendModal.open} className="shareModal">
            <ModalHeader
              toggle={() => {
                setEmailSmsSendModal({ open: false, type: "" })
                setListingType(undefined);
                setHasSearched(false);
                setCurrentFilters([]);
                setShowShareConfirm({
                  display: false,
                  emails: 0,
                  sms: 0,
                });
              }


              }
            >
              {emailSmsSendModal.type == "EMAIL_LINK"
                ? "Email a Link"
                : emailSmsSendModal.type == "SURVEY_LINK"
                  ? "Text a Link"
                  : emailSmsSendModal.type == "COPY_LINK"
                    ? "Copy Link"
                    : emailSmsSendModal.type == "QR_CODE"
                      ? "QR Code"
                      : emailSmsSendModal.type == "WHATSAPP"
                        ? "WhatsApp"
                        : "Text ONLY"}
            </ModalHeader>
            <ModalBody className="pb-4">
              {showNoChangeAlert() &&
                triviaShareAndPrivacy.sharedWithUsers.length > 0 && (
                  <Alert color="info" className="mt-5">
                    All invited users have already received an email and/or SMS
                    text. To share Trivvy, please invite more users.
                  </Alert>
                )}

              {
                (emailSmsSendModal.type !== "COPY_LINK" &&
                  emailSmsSendModal.type !== "QR_CODE" &&
                  emailSmsSendModal.type !== "WHATSAPP") ? <div className="mt-3">
                  <Alert color="info">
                    <p className="mb-0"> <b>Note:</b> <div className="d-flex flex-column">
                      <Note />
                    </div></p>
                  </Alert>
                </div> : <></>
              }



              {
                (emailSmsSendModal.type === "EMAIL_LINK" && survey && !survey.isMessaging) ||
                emailSmsSendModal.type === "SURVEY_LINK" ||
                emailSmsSendModal.type === "COPY_LINK" ||
                emailSmsSendModal.type === "QR_CODE" ||
                emailSmsSendModal.type === "WHATSAPP" ? <>
                <Card className="pt-2 px-4 sharepage_top_card">
                  <div
                    className="d-flex"
                    style={{
                      ...(isMobile && {
                        flexDirection: "column",
                        gap: "15px",
                      }),
                    }}
                  >
                  </div>

                  <div className="d-flex flex-column">
                    <Row className={`mt-3 share-quiz-privacy`}>
                      <Col md={6} sm={12} lg={6} xs={12}>
                        <div className="row text-left my-3">
                          <div className="col-md-5 col-lg-5 text-left">
                            <h5>Sharing <br />Permissions:</h5>
                          </div>
                          <div className="col-md-7 col-lg-7 enterprise-settings-value">
                            <Select
                              className="pt-0"
                              value={privacy}
                              onChange={(val) => {

                                setTriviaShareAndPrivacy({
                                  ...triviaShareAndPrivacy,
                                  privacy: val.value,
                                });
                                callApiToAutoSave("privacy", val.value);
                                setCurrentTrivia({
                                  ...survey,
                                  privacy: val.value,
                                });
                              }}
                              options={TRIVIA_SHARE_PRIVACY_OPTIONS}
                              placeholder="Select Privacy"
                              disabled={!isSharable}
                            />
                          </div>
                        </div>
                      </Col>

                      <Col md={6} sm={12} lg={6} xs={12}>
                        {privacy == "PUBLIC" && (
                          <div
                            data-tip={
                              planInvalid
                                ? "Upgrade your plan to Premium or above to enable this feature"
                                : ""
                            }
                          >
                            <div className="row text-left my-3">
                              <div className="col-md-5 col-lg-5 text-left">
                                <h5>User must provide:</h5>
                              </div>
                              <div className="col-md-7 col-lg-7 enterprise-settings-value">
                                <Select
                                  className="pt-0"
                                  value={userIdentification}
                                  onChange={(val) => {
                                    setUserIdentification(val.value);
                                    callApiToAutoSave("userIdentificationOptions", [
                                      val.value,
                                    ]);
                                    setCurrentTrivia({
                                      ...survey,
                                      userIdentificationOptions: [val.value],
                                    });
                                  }}
                                  options={TRIVIA_USER_IDENTIFICATION_OPTIONS}
                                  placeholder="Select User Identification"
                                  disabled={planInvalid}
                                />{" "}
                              </div>
                            </div>

                            <ReactTooltip />
                          </div>
                        )}
                      </Col>
                    </Row>
                    {
                      privacy === "PUBLIC" && <div style={{marginLeft: '-16px', fontSize: '12px'}}>
                        <Col md={6} sm={12} lg={6} xs={12}>
                          <Alert color="info" className=""><b>NOTE:</b> This means anyone can receive the Trivvy.</Alert>
                        </Col>
                      </div>
                    }
                  </div>
                </Card>
              </> : <></>
              }

              {/* Copy Link Content */}
              {emailSmsSendModal.type === "COPY_LINK" && (
                <div className="mt-4 text-center">
                  <h5>Copy Link to Share</h5>
                  <div className="d-flex justify-content-center align-items-center mt-3">
                    <input
                      type="text"
                      className="form-control"
                      value={`${shareUrl}?medium=copy`}
                      readOnly
                      style={{ maxWidth: '500px' }}
                    />
                    <Button
                      color="primary"
                      className="ml-2"
                      onClick={() => {
                        copySurveyUrl();
                        toastContainer("Link copied!", "success");
                      }}
                    >
                      <FaRegCopy /> Copy
                    </Button>
                  </div>
                </div>
              )}

              {/* QR Code Content */}
              {emailSmsSendModal.type === "QR_CODE" && (
                <div className="mt-4 text-center">
                  <h5>QR Code</h5>
                  <div className="mt-3">
                    <QRCodeCanvas
                      id="qrcode-canvas-display"
                      level="H"
                      size={200}
                      value={shareUrl + "?medium=qrcode"}
                    />
                  </div>
                  <div className="mt-3">
                    <Button
                      color="primary"
                      onClick={() => {
                        downloadQRCode();
                      }}
                    >
                      <IoQrCodeOutline size={20} className="mr-1" /> Download QR Code
                    </Button>
                  </div>
                </div>
              )}

              {/* WhatsApp Content */}
              {emailSmsSendModal.type === "WHATSAPP" && (
                <div className="mt-4 text-center">
                  <h5>Share via WhatsApp</h5>
                  <p className="mt-3">Click the button below to share this Trivvy via WhatsApp</p>
                  <div className="mt-3">
                    <Button
                      color="success"
                      onClick={() => {
                        window.open(
                          `https://wa.me/?text=${encodeURIComponent(
                            shareUrl + "?medium=whatsapp"
                          )}`
                        );
                      }}
                      style={{ backgroundColor: '#25D366' }}
                    >
                      <FaWhatsapp size={20} className="mr-2" /> Share on WhatsApp
                    </Button>
                  </div>
                </div>
              )}


              {(emailSmsSendModal.type === "EMAIL_LINK" ||
                emailSmsSendModal.type === "SURVEY_LINK" ||
                emailSmsSendModal.type === "SMS_TRIVVY") && tableUI}

              {listingType === "saved" && (
                <div>
                  {showLimitSMSAlert && showLimitSMSAlert.display ? (
                    <Alert
                      style={{ backgroundColor: "rgb(212 233 237 / 75%)" }}
                    >
                      {showLimitSMSAlert.remainingLimit ? (
                        <span>
                          You have only {showLimitSMSAlert.remainingLimit} SMS
                          left and you are sending {showLimitSMSAlert.totalSMS}{" "}
                          SMS, So only first {showLimitSMSAlert.remainingLimit}{" "}
                          will recieve SMS notifications. Do you want to
                          continue?
                        </span>
                      ) : (
                        <span>
                          You have only {showLimitSMSAlert.remainingLimit} SMS
                          left and you are sending {showLimitSMSAlert.totalSMS}{" "}
                          SMS, So no one will recieve SMS notifications. Do you
                          want to continue?
                        </span>
                      )}

                      <div className="mt-3">
                        <Button
                          color="success"
                          onClick={() => {
                            setAllowSendLimitSMS(true);
                          }}
                        >
                          Continue
                        </Button>{" "}
                        <Button
                          onClick={() => {
                            setShowLimitSMSAlert({
                              display: false,
                              remainingLimit: 0,
                              totalSMS: 0,
                            });
                          }}
                          className="ml-3"
                          color="danger"
                        >
                          Cancel
                        </Button>
                      </div>
                    </Alert>
                  ) : (
                    ""
                  )}
                  {emailSmsSendModal.type == "SMS_TRIVVY" && !survey.isMessaging ? (
                    <SendSmsTextQuestionsModal
                      trivia={survey}
                      editCurrentTriviaShareData={editCurrentTriviaShareData}
                      usersChanged={usersChanged}
                      smsUsersData={smsEmailUsersData}
                      setSmsUsersData={setSmsEmailUsersData}
                      setUsersChanged={setUsersChanged}
                      listingType={listingType}
                      trivvyResults={trivvyResults}
                      setTrivvyResults={setTrivvyResults}
                      onAfterSend={() => {
                        const afterSendDate = new Date().toISOString();
                        setTriviaShareAndPrivacy((prev) => ({
                          ...prev,
                          sharedWithUsers: (prev.sharedWithUsers || []).map((user) => {
                            const updated = Object.assign({}, user);
                            updated.smsDate = afterSendDate;
                            return updated;
                          }),
                        }));
                      }}
                    />
                  ) : (
                    <div>
                      <div>
                        {showShareconfirm.display ? (
                          <>
                            <Alert>
                              <div>

                                {
                                  messagingUsersData && messagingUsersData.allUsersResponded && 'All users have already responded to this Trivvy.'
                                }

                                {
                                  showShareconfirm && showShareconfirm.allUsersTakenTrivvy ? 'All users have already completed this Trivvy.' : ''
                                }

                                {((messagingUsersData &&
                                  !messagingUsersData.allUsersResponded) || (!messagingUsersData && !showShareconfirm.allUsersTakenTrivvy)) && <>
                                    Are you sure you want to share this {survey.isMessaging ? <b>Trivvy</b> : 'Trivvy'} with
                                    the user(s)?
                                    <br />
                                    {showShareconfirm.emails > 0 ||
                                      showShareconfirm.sms > 0
                                      ? "This will send"
                                      : ""}
                                    {showShareconfirm.emails > 0 ? (
                                      <b>
                                        {" "}
                                        {showShareconfirm.emails}{" "}
                                        {showShareconfirm.emails == 1
                                          ? "Email"
                                          : "Emails"}{" "}
                                      </b>
                                    ) : (
                                      ""
                                    )}
                                    {showShareconfirm.sms > 0 ? (
                                      <b> {numSmsToSend} SMS Text</b>
                                    ) : (
                                      ""
                                    )}
                                    {showShareconfirm.emails > 0 ||
                                      showShareconfirm.sms > 0
                                      ? "."
                                      : ""}
                                  </>
                                }



                              </div>
                              {/* Share confirm success SEND TRIVVY TEXT */}
                              <div className="mt-2">
                                <Button
                                  color="success"
                                  size="sm"
                                  disabled={(messagingUsersData && messagingUsersData.alreadySentMobiles.length > 0 && (messagingUsersData.allUsersResponded || (messagingUsersData.pendingUsersToRespond > 0 && displayPendingToSendAlert))) || (showShareconfirm.allUsersTakenTrivvy || showShareconfirm.showResendOption)}
                                  onClick={() => {
                                    if (shareTrivvyViaEmail) handleClickShareButton(true);
                                    if (shareTrivvyViaSMS) {
                                      handleSendSMS(true);
                                    }
                                    setShowDroppedUsersAlert(false)
                                    setShowShareConfirm({
                                      display: false,
                                      sms: 0,
                                      emails: 0,
                                    });
                                  }}
                                >
                                  Ok
                                </Button>

                                <Button
                                  color="danger"
                                  size="sm"
                                  onClick={() => {
                                    setShowDroppedUsersAlert(false)
                                    setShowShareConfirm({
                                      display: false,
                                      sms: 0,
                                      emails: 0,
                                    });
                                  }}
                                  className="ml-3"
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Alert>


                            {((displayPendingToSendAlert > 0 && messagingUsersData && messagingUsersData.pendingUsersToRespond && messagingUsersData.alreadySentMobiles.length > 0) || showShareconfirm.showResendOption)
                              ? (
                                <Alert color="warning">
                                  {showShareconfirm && showShareconfirm.showResendOption ? showShareconfirm.pendingUsersToRespond : alreadyReceivedSms} {(showShareconfirm && showShareconfirm.pendingUsersToRespond > 1) || alreadyReceivedSms > 1 ? "users" : "user"} {alreadyReceivedSms > 1 || (showShareconfirm && showShareconfirm.pendingUsersToRespond > 1) ? "have" : "has"} already received the Trivvy and  {alreadyReceivedSms > 1 || (showShareconfirm && showShareconfirm.pendingUsersToRespond > 1) ? "have" : "has"} not {showShareconfirm && showShareconfirm.showResendOption && !survey.isMessaging ? 'completed' : 'responded'} yet.
                                  <br />
                                  <div className="d-flex mt-3">
                                    <Button
                                      color="success"
                                      onClick={() => {
                                        if (showShareconfirm && showShareconfirm.showResendOption) {
                                          setShowShareConfirm(prev => ({
                                            ...prev,
                                            showResendOption: false,
                                          }));
                                          setSendToDroppedUsers("YES");
                                        } else {
                                          setDisplayPendingToSendAlert(false);
                                          setSendToDroppedUsers("YES");
                                        }
                                      }}
                                    >
                                      Re-Send again
                                    </Button>{" "}
                                    <Button
                                      color="danger"
                                      className="ml-3"
                                      onClick={() => {
                                        if (showShareconfirm && showShareconfirm.showResendOption) {
                                          if (showShareconfirm.emails == showShareconfirm.pendingUsersToRespond) {
                                            setShowShareConfirm({
                                              display: false,
                                              sms: 0,
                                              emails: 0,
                                            });
                                          } else {
                                            setSendToDroppedUsers("NO");
                                            setShowShareConfirm(prev => ({
                                              ...prev,
                                              showResendOption: false,
                                              emails: showShareconfirm.emails - showShareconfirm.pendingUsersToRespond,
                                            }));
                                          }
                                        } else {
                                          if (!newUsersToSendSms) {
                                            setIsConfirmNewUsersToSendSms(false)
                                            setShowDroppedUsersAlert(false);
                                            setShowShareConfirm({
                                              display: false,
                                              sms: 0,
                                              emails: 0,
                                            });
                                          } else setIsConfirmNewUsersToSendSms(true)
                                          setDisplayPendingToSendAlert(false);
                                          setSendToDroppedUsers("NO");
                                        }
                                      }}
                                    >
                                      Don't resend
                                    </Button>
                                  </div>
                                </Alert>
                              ) : <></>}
                          </>

                        ) : (
                          <div
                            className={
                              (usersChanged && listingType === "new")
                                ? "flex justify-content-center align-items-center"
                                : "flex justify-content-end align-items-center"
                            }
                          >
                            {!survey.isMessaging && emailSmsSendModal.type !== "COPY_LINK" && emailSmsSendModal.type !== "QR_CODE" && emailSmsSendModal.type !== "WHATSAPP" && (
                              <Button
                                disabled={
                                  !isSharable ||
                                  showNoChangeAlert() ||
                                  (triviaShareAndPrivacy.privacy === "CUSTOM" &&
                                    triviaShareAndPrivacy.sharedWithUsers
                                      .length == 0) ||
                                  (!shareTrivvyViaEmail && !shareTrivvyViaSMS) || (smsEmailUsersData && smsEmailUsersData.totalUsers === 0 && emailSmsSendModal && (emailSmsSendModal.type == "EMAIL_LINK" || emailSmsSendModal.type == "SURVEY_LINK")) ||
                                  (hasScheduledDate && !isScheduledDateInPast)
                                }
                                onClick={() => handleClickShareButton(false)}
                                className="share-via-trivvy-button trivia-action-button-main mr-2 mt-2"
                              >
                                <span style={{ fontSize: "16px" }}>Share Trivvy Link</span>

                              </Button>
                            )}

                            {(usersChanged && listingType === "new") ? (
                              <Alert className=" mb-0 w-100" color="info">
                                Please <strong>Save invited users</strong> first
                                to Share Trivvy Link to them
                              </Alert>
                            ) : null}                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </ModalBody>
          </Modal>

        </Col>
      </Row >
    </div >
  );
}
